/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './pages/__root'
import { Route as StaffRouteImport } from './pages/staff'
import { Route as ShiftsRouteImport } from './pages/shifts'
import { Route as SettingsRouteImport } from './pages/settings'
import { Route as SessionsRouteImport } from './pages/sessions'
import { Route as ProfileRouteImport } from './pages/profile'
import { Route as HomeRouteImport } from './pages/home'
import { Route as ClinicsRouteImport } from './pages/clinics'
import { Route as IndexRouteImport } from './pages/index'
import { Route as TreatmentsIndexRouteImport } from './pages/Treatments/index'
import { Route as NotFoundIndexRouteImport } from './pages/NotFound/index'

const StaffRoute = StaffRouteImport.update({
  id: '/staff',
  path: '/staff',
  getParentRoute: () => rootRouteImport,
} as any)
const ShiftsRoute = ShiftsRouteImport.update({
  id: '/shifts',
  path: '/shifts',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const SessionsRoute = SessionsRouteImport.update({
  id: '/sessions',
  path: '/sessions',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileRoute = ProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const HomeRoute = HomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => rootRouteImport,
} as any)
const ClinicsRoute = ClinicsRouteImport.update({
  id: '/clinics',
  path: '/clinics',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const TreatmentsIndexRoute = TreatmentsIndexRouteImport.update({
  id: '/Treatments/',
  path: '/Treatments/',
  getParentRoute: () => rootRouteImport,
} as any)
const NotFoundIndexRoute = NotFoundIndexRouteImport.update({
  id: '/NotFound/',
  path: '/NotFound/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/clinics': typeof ClinicsRoute
  '/home': typeof HomeRoute
  '/profile': typeof ProfileRoute
  '/sessions': typeof SessionsRoute
  '/settings': typeof SettingsRoute
  '/shifts': typeof ShiftsRoute
  '/staff': typeof StaffRoute
  '/NotFound': typeof NotFoundIndexRoute
  '/Treatments': typeof TreatmentsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/clinics': typeof ClinicsRoute
  '/home': typeof HomeRoute
  '/profile': typeof ProfileRoute
  '/sessions': typeof SessionsRoute
  '/settings': typeof SettingsRoute
  '/shifts': typeof ShiftsRoute
  '/staff': typeof StaffRoute
  '/NotFound': typeof NotFoundIndexRoute
  '/Treatments': typeof TreatmentsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/clinics': typeof ClinicsRoute
  '/home': typeof HomeRoute
  '/profile': typeof ProfileRoute
  '/sessions': typeof SessionsRoute
  '/settings': typeof SettingsRoute
  '/shifts': typeof ShiftsRoute
  '/staff': typeof StaffRoute
  '/NotFound/': typeof NotFoundIndexRoute
  '/Treatments/': typeof TreatmentsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/clinics'
    | '/home'
    | '/profile'
    | '/sessions'
    | '/settings'
    | '/shifts'
    | '/staff'
    | '/NotFound'
    | '/Treatments'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/clinics'
    | '/home'
    | '/profile'
    | '/sessions'
    | '/settings'
    | '/shifts'
    | '/staff'
    | '/NotFound'
    | '/Treatments'
  id:
    | '__root__'
    | '/'
    | '/clinics'
    | '/home'
    | '/profile'
    | '/sessions'
    | '/settings'
    | '/shifts'
    | '/staff'
    | '/NotFound/'
    | '/Treatments/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ClinicsRoute: typeof ClinicsRoute
  HomeRoute: typeof HomeRoute
  ProfileRoute: typeof ProfileRoute
  SessionsRoute: typeof SessionsRoute
  SettingsRoute: typeof SettingsRoute
  ShiftsRoute: typeof ShiftsRoute
  StaffRoute: typeof StaffRoute
  NotFoundIndexRoute: typeof NotFoundIndexRoute
  TreatmentsIndexRoute: typeof TreatmentsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/staff': {
      id: '/staff'
      path: '/staff'
      fullPath: '/staff'
      preLoaderRoute: typeof StaffRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/shifts': {
      id: '/shifts'
      path: '/shifts'
      fullPath: '/shifts'
      preLoaderRoute: typeof ShiftsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sessions': {
      id: '/sessions'
      path: '/sessions'
      fullPath: '/sessions'
      preLoaderRoute: typeof SessionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile': {
      id: '/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/home': {
      id: '/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof HomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clinics': {
      id: '/clinics'
      path: '/clinics'
      fullPath: '/clinics'
      preLoaderRoute: typeof ClinicsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/Treatments/': {
      id: '/Treatments/'
      path: '/Treatments'
      fullPath: '/Treatments'
      preLoaderRoute: typeof TreatmentsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/NotFound/': {
      id: '/NotFound/'
      path: '/NotFound'
      fullPath: '/NotFound'
      preLoaderRoute: typeof NotFoundIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ClinicsRoute: ClinicsRoute,
  HomeRoute: HomeRoute,
  ProfileRoute: ProfileRoute,
  SessionsRoute: SessionsRoute,
  SettingsRoute: SettingsRoute,
  ShiftsRoute: ShiftsRoute,
  StaffRoute: StaffRoute,
  NotFoundIndexRoute: NotFoundIndexRoute,
  TreatmentsIndexRoute: TreatmentsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
